import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component CrownBlankIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <CrownBlankIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <CrownBlankIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CrownBlankIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="CrownBlankIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        d="M15.674 9.488l2.704-.98L17.3 13H6.7L5.663 8.507l2.662.978A1 1 0 009.45 9.17L12 5.988l2.552 3.186a1 1 0 001.122.314zM8.5 7.482L4.69 6.097a1 1 0 00-1.32 1.145L5 15h14l1.63-7.758a1 1 0 00-1.32-1.145L15.5 7.482l-2.747-3.14a1 1 0 00-1.506 0L8.5 7.482zM19 17H5v1c0 .6.4 1 1 1h12c.6 0 1-.4 1-1v-1z"
        fillRule="evenodd"
      />
    </svg>
  )
);
CrownBlankIcon.displayName = "CrownBlankIcon";
export default CrownBlankIcon;
